module.exports = __webpack_public_path__ + "public/img/Membuat Konten Sosial Media untuk Marketing Online.f6fd6900.png";